import _ from 'lodash';
import { SelectOption } from 'global';
import { DiscountType } from '@trnsact/trnsact-shared-types';
import { EQUIPMENT_CLASS, EQUIPMENT_MAKE } from '@trnsact/business-criteria';
import { convertEnumValuesToSelectOptions } from '../../../utils/selectOptionsHelper';

export const equipmentConditions: SelectOption[] = [
  { label: 'New', value: 'new' },
  { label: 'Used', value: 'used' },
  { label: 'Demo', value: 'demo' },
  { label: 'Reconditioned', value: 'reconditioned' },
];

export const equipmentAttachmentTypes: SelectOption[] = [
  { label: 'Trailer', value: 'Trailer' },
  { label: 'Body', value: 'Body' },
  { label: 'Attachment', value: 'Attachment' },
];

export const discountTypes: SelectOption<DiscountType>[] = [
  { label: 'Flat', value: DiscountType.Flat },
  { label: 'Percentage', value: DiscountType.Percent },
];

export const makeOptions = convertEnumValuesToSelectOptions(EQUIPMENT_MAKE);

export const classOptions = convertEnumValuesToSelectOptions(EQUIPMENT_CLASS);

export const equipmentYears = _.range(1990, new Date().getFullYear() + 3)
  .reverse()
  .map(value => ({
    label: value.toString(),
    value: value.toString(),
  }));
